const headsFilters = [
    {
        filterDisplayName: "Standard",
        filterType: "collection",
        filterHandle: "ungendered-heads",
        subFilters: false,
    },
    {
        filterDisplayName: "Glasses",
        filterType: "collection",
        filterHandle: "glasses-heads",
        subFilters: false,
    },
    {
        filterDisplayName: "Beards",
        filterType: "collection",
        filterHandle: "beard-heads",
        subFilters: false,
    },
    {
        filterDisplayName: "Feminine",
        filterType: "collection",
        filterHandle: "makeup-heads",
        subFilters: false,
    },
    {
        filterDisplayName: "Children",
        filterType: "collection",
        filterHandle: "childrens-heads",
        subFilters: false,
    },
]

export { headsFilters }
